import { actionTypes } from '../../../types';

export const optAndSubmitContentLink = (payload, callback) => ({
    type: actionTypes.OPT_AND_SUBMIT_CONTENT_LINK_REQUEST,
    payload,
    callback
});

export const optAndSubmitContentLinkSuccess = (payload) => ({
    type: actionTypes.OPT_AND_SUBMIT_CONTENT_LINK_SUCCESS,
    payload,
});

export const optAndSubmitContentLinkFailure = (payload) => ({
    type: actionTypes.OPT_AND_SUBMIT_CONTENT_LINK_FAILURE,
    payload,
});

export const optAndSubmitContentLinkReset = () => ({
    type: actionTypes.OPT_AND_SUBMIT_CONTENT_LINK_RESET,
});

export const optAndSubmitContentLinkResetAll = () => ({
    type: actionTypes.OPT_AND_SUBMIT_CONTENT_LINK_RESET_ALL,
});
